const riot = require('riot');
import '../components/audiences.tag'
riot.tag2('page-audiences', '<audiences></audiences>', '', '', function(opts) {
});
